import {
  Users,
  GraduationCap,
  Building2,
  Trophy,
  School,
  Target,
  Handshake,
  Heart,
  MapPin,
  TrendingUp,
} from "lucide-react";

export const KPL_LOGO = "https://customer-assets.emergentagent.com/job_league-relaunch/artifacts/9nlr2euh_Unknown.jpeg";
export const KENYA_ADMIN_MAP = "https://customer-assets.emergentagent.com/job_dc5457d3-8c6e-4cbe-be68-a12e9dc5cfb8/artifacts/topfrxy6_1776022680908-65e5a583-515c-450e-bd8b-79e6a7ff5768_1.png";

export const CASE_LAW = {
  title:
    "Opiyo Taiwo Leo Atieno Awuonda (suing on his behalf and on behalf of the larger public/community that is a beneficiary of effective sports activities and management) v Registrar of Companies & another [2022] KEHC 1199 (KLR)",
  shortTitle:
    "Opiyo Taiwo Leo Atieno Awuonda v Registrar of Companies & another [2022] KEHC 1199 (KLR)",
  url: "https://new.kenyalaw.org/akn/ke/judgment/kehc/2022/1199/eng@2022-03-31",
  meta: "High Court at Migori · 31 March 2022",
  summary:
    "The court emphasized fair administrative action in company registration and ordered registration of the proposed football club company subject to a no-objection letter from the Sports Registrar.",
};

export const KENYA_GDP_PPP_NOTE =
  "Kenya's GDP (Purchasing Power Parity - PPP) is projected to reach approximately $430-$539 billion by 2025–2026.";
export const KENYA_GDP_PPP_RANGE = "$430-$539B";
export const NAIROBI_GDP_PPP_RANGE = "$97B";
export const OUTSIDE_NAIROBI_GDP_PPP_RANGE = "$333-$442B";
export const KENYA_AVERAGE_AGE = "21";
export const NAIROBI_POPULATION = "7M";
export const OUTSIDE_NAIROBI_POPULATION = "48M";
export const CLUBS_IN_NAIROBI_PERCENT = "67%";
export const OUTSIDE_NAIROBI_POPULATION_PERCENT = "87%";
export const KPL_COMPANY_DETAILS =
  "Kenya Premier League Limited is a Limited Liability Company registered and incorporated in the Republic of Kenya. Company no. C.106565.";

export const navLinks = [
  {
    label: "About",
    href: "/about-kpl",
  },
  {
    label: "Strategic Plan",
    href: "#",
    children: [
      { label: "Vision", href: "#vision" },
      { label: "Objectives", href: "#objectives" },
      { label: "Roadmap", href: "#roadmap" },
      { label: "Kenya in Numbers", href: "#kenya" },
      { label: "Challenge", href: "#challenge" },
    ],
  },
  {
    label: "The League",
    href: "#",
    children: [
      { label: "League Table", href: "/league-table" },
      { label: "Fixtures", href: "/fixtures" },
      { label: "Results", href: "/results" },
      { label: "Fantasy", href: "/fantasy" },
    ],
  },
  {
    label: "Contact",
    href: "#contact",
  },
];

export const mobileNavLinks = [
  {
    label: "About",
    href: "/about-kpl",
  },
  {
    label: "Strategic Plan",
    href: "#",
    children: [
      { label: "Vision", href: "#vision" },
      { label: "Objectives", href: "#objectives" },
      { label: "Roadmap", href: "#roadmap" },
      { label: "Kenya In Numbers", href: "#kenya" },
      { label: "Challenge", href: "#challenge" },
    ],
  },
  {
    label: "The League",
    href: "#",
    children: [
      { label: "League Table", href: "/league-table" },
      { label: "Fixtures", href: "/fixtures" },
      { label: "Results", href: "/results" },
      { label: "Fantasy", href: "/fantasy" },
    ],
  },
  {
    label: "Contact",
    href: "#contact",
  },
];

export const summaryCards = [
  {
    title: "Executive Summary",
    body: "Re-structuring, re-branding, and repositioning the Kenya Premier League around youth, community, governance, and long-term sustainability.",
  },
  {
    title: "Organisation",
    body: "Kenya Premier League Limited was incorporated in 2003 and serves 18 member clubs in the professional game, with governance, AGM, and shareholder structures at the core of delivery.",
  },
  {
    title: "Delivering Our Goals",
    body: "The plan depends on talented and engaged people, better club structures, and stronger communication with stakeholders, media, sponsors, and schools.",
  },
];

export const stakeholderGroups = [
  "Member Clubs",
  "FKF",
  "FIFA",
  "CAF",
  "Schools",
  "Media",
  "Sponsors",
  "Private Sector",
  "Local Communities",
];

export const aboutIdentityCards = [
  {
    title: "Incorporation",
    body: "Kenyan Premier League Ltd is a private company incorporated in October 2003 under the Companies Act of Kenya.",
  },
  {
    title: "Ownership",
    body: "KPL is fully owned and managed by the eighteen Premier League clubs.",
  },
  {
    title: "Affiliation",
    body: "KPL is affiliated to the Football Kenya Federation (FKF), which is also a KPL special shareholder and voting member of the KPL Board of Directors.",
  },
];

export const aboutMission =
  "Our mission is to build professionalism on and off the field in the Kenyan Premier League and its participating clubs, coaches, players and referees, and to ensure we always act together for the good of our sport and nation.";

export const aboutMotto = "For the good of our sport and nation.";

export const aboutGoals = [
  "Raise the professional standards and performance of clubs, coaches, players and referees.",
  "Improve the competitiveness and attractiveness of the league for fans, sponsors and media.",
  "Secure and apply sponsorships and other revenue to strengthen the future of the league and its clubs.",
  "Provide a professional and competitive basis for clubs and national teams to represent Kenya internationally.",
  "Undertake new programmes within and among clubs that contribute to community and national development, and greater national unity.",
  "Contribute to the improvement of football in Kenya and abroad through cooperation with clubs and associations in Kenya and with CECAFA, CAF and FIFA.",
];

export const aboutValues = [
  { title: "Democratic ownership", body: "All clubs hold equal shares in KPL." },
  { title: "Democratic decision-making", body: "All clubs hold equal votes in the league structure." },
  { title: "Fair play", body: "Every club stands equal under the rules of the game." },
  {
    title: "Leadership on merit",
    body: "The Chairman comes from the highest-ranked club of the previous season, with Vice Chairmen from the next two highest-ranked clubs.",
  },
  {
    title: "Good governance",
    body: "The Governing Council meets quarterly and brings together the chairmen of the 18 Premier League clubs plus FKF.",
  },
  { title: "Transparency", body: "Governing Council meetings and records of decisions are open to the media." },
  { title: "Financial accountability", body: "Members, sponsors and the media can review KPL financial records and accounts." },
  {
    title: "National development",
    body: "Clubs support local and national development through projects on issues such as AIDS prevention, environmental improvement, and alcohol or drug abuse.",
  },
  {
    title: "National unity",
    body: "KPL members come from across the country and maintain zero tolerance for tribalism, racism, corruption, hooliganism, or discrimination based on religion, gender or disability.",
  },
];

export const aboutCharterPoints = [
  "Play to win, play fair, and accept both victory and defeat with dignity.",
  "Respect KPL and other club officials, match officials, and spectators.",
  "Reject corruption, hooliganism, banned substances, racism, and discrimination of any kind.",
  "Behave with utmost good faith and honesty in all relations with KPL and other clubs.",
  "Act in a manner that does not bring KPL or the game into disrepute.",
  "Comply with the Laws of the Game and KPL, FKF, CECAFA, CAF and FIFA rules and policies.",
  "Inform officials and players on the relevant rules and ensure they respect them.",
  "Respect the contractual responsibilities and obligations of employees of another club.",
  "Discharge financial obligations to KPL and other clubs promptly and fully.",
  "Seek to resolve differences with KPL or other clubs without recourse to a court of law.",
];

export const aboutCooperationPoints = [
  "KPL and the Premier League clubs are members of FKF and pay a consolidated annual affiliation fee agreed by the FKF-KPL Joint Executive Committee (JEC), made up of three FKF appointees and three KPL appointees, chaired on an alternating basis.",
  "The JEC helps coordinate the annual football calendar, considers changes to the rules of governing Kenyan football, supports joint projects such as coach and referee training plus youth development, and approves annually the selection of top referees for Premier League matches.",
  "The FKF National Executive Committee includes one KPL representative appointed by the KPL Governing Council, while FKF Annual and Special General Meetings include the chairmen of the eighteen Premier League clubs as voting members.",
];

export const aboutHistoryHighlights = [
  {
    year: "2003",
    title: "Incorporation",
    body: "Kenyan Premier League Limited was incorporated on 31 October 2003 as a private company limited by shares under Chapter 486 of the Companies Act of the Laws of Kenya.",
  },
  {
    year: "2003",
    title: "Kenyan Champions League",
    body: "KPL launched and successfully managed the Kenyan Champions League, one of the most competitive and fair-play driven leagues in Kenyan football history. The 2003–04 champions were Utalii FC with Tusker FC as runners-up.",
  },
  {
    year: "2003",
    title: "First Transparency Cup",
    body: "In November and December 2003, KPL launched the world’s first Transparency Cup under the theme ‘Kicking corruption out of football’. Utalii FC were champions and Gor Mahia FC runners-up.",
  },
  {
    year: "2004",
    title: "Second Transparency Cup",
    body: "Between March and July 2004, KPL organized the second Transparency Cup. Kenya Commercial Bank FC were champions and Thika United FC were runners-up.",
  },
  {
    year: "2004",
    title: "Football Roll of Honour",
    body: "KPL created the first Football Roll of Honour to recognise leaders who dedicated themselves to improving Kenyan football, granting the first eleven inductees lifetime entry to all KPL matches.",
  },
  {
    year: "2005/06",
    title: "Kenyan Premier League",
    body: "With the agreement of the then KFF, CAF and FIFA, KPL took over ownership and management of the Premier League, overseeing a highly competitive season in which over two-thirds of matches ended in victories and 90% were one- or two-goal wins or draws.",
  },
  {
    year: "2005",
    title: "Office, Staff and Outreach",
    body: "KPL established a new headquarters in Riadha House in central Nairobi, appointed a Managing Director and assistant, and operated an additional office co-located with the FKL at the FIFA GOAL Project headquarters in Kasarani.",
  },
  {
    year: "2006",
    title: "Stopping hooliganism",
    body: "After serious incidents in February 2006, KPL adopted a zero-tolerance policy against hooliganism and attacks on referees. In more than 400 matches since then, only three attacks on referees were recorded and all were firmly dealt with.",
  },
  {
    year: "2003–07",
    title: "Support to national teams",
    body: "During 2003–07, KPL clubs supplied the majority of national team players and voluntarily released them for longer periods than required under FIFA rules.",
  },
  {
    year: "2006",
    title: "Cairo Agreements",
    body: "A watershed moment came with the FIFA-convened Cairo meetings in January 2006, bringing together FIFA, CAF, Kenyan sports ministry leaders, FKL officials and KPL club representatives to help protect the integrity and future of Kenyan football.",
  },
];

export const kenyaCities = [
  {
    x: 200,
    y: 260,
    name: "Nairobi",
    focus: "Commercial and governance anchor",
    info: "67% of clubs currently operate from Nairobi, making it the league’s current centre of gravity.",
    opportunity: "The strategy aims to turn Nairobi’s concentration into a launchpad for better governance, investment, and wider national reach.",
    isMain: true,
  },
  {
    x: 320,
    y: 340,
    name: "Mombasa",
    focus: "Coastal expansion corridor",
    info: "Mombasa represents a major coastal growth zone for football visibility, youth pathways, and community activation.",
    opportunity: "Expanding here grows the league beyond Nairobi and connects football development to the coast’s commercial energy.",
  },
  {
    x: 100,
    y: 280,
    name: "Kisumu",
    focus: "Western Kenya hub",
    info: "Kisumu strengthens western access and brings the strategic plan closer to more counties and supporters.",
    opportunity: "It supports regional talent discovery and a broader community-based football footprint.",
  },
  {
    x: 160,
    y: 200,
    name: "Nakuru",
    focus: "Rift Valley connector",
    info: "Nakuru sits in a key corridor for club operations, movement, and fan access across the Rift Valley.",
    opportunity: "It can help distribute football activity more evenly across central and western regions.",
  },
  {
    x: 260,
    y: 160,
    name: "Meru",
    focus: "Eastern development node",
    info: "Meru signals eastern expansion and a more balanced national approach to football infrastructure and participation.",
    opportunity: "The region can support new club pathways, youth development, and stronger local engagement.",
  },
  {
    x: 90,
    y: 200,
    name: "Eldoret",
    focus: "High-performance potential",
    info: "Eldoret’s sporting reputation makes it a compelling location for disciplined youth development and elite preparation.",
    opportunity: "It adds a high-performance dimension to the league’s longer-term national growth strategy.",
  },
];

export const objectives = [
  {
    number: "01",
    icon: Users,
    title: "Grass Roots",
    subtitle: "Primary/Secondary Schools Programme",
    description:
      "Creating positive and lasting sporting, health and education outcomes for children and the wider community.",
  },
  {
    number: "02",
    icon: GraduationCap,
    title: "Football Business Academy",
    subtitle: "Education & Training",
    description:
      "Developing skills and capacity in those wanting to learn all the variables of running a Professional Football Club.",
  },
  {
    number: "03",
    icon: Building2,
    title: "Club Structures",
    subtitle: "Corporate Governance",
    description:
      "Guiding Member Clubs on best legal structures to attract capital and strategic investors.",
  },
  {
    number: "04",
    icon: Trophy,
    title: "Multi-Sports Division",
    subtitle: "New Opportunities",
    description:
      "Building facilities for young people to play more professional sports and attract more fans and sponsors.",
  },
];

export const roadmapMilestones = [
  {
    year: "2022",
    title: "Foundation Year",
    items: ["Strategic Plan Launch", "Stakeholder Consultations"],
    legalReference: CASE_LAW,
  },
  {
    year: "2023",
    title: "Building Blocks",
    items: [
      "Academy Curriculum Development",
      "Governance Framework",
      "Partnership Development — early partner engagement",
    ],
  },
  {
    year: "2024",
    title: "Partnership Momentum",
    items: [
      "Partnership Development — commercial and community partners onboarded",
    ],
  },
  {
    year: "2025",
    title: "Partnership Consolidation",
    items: [
      "Partnership Development — long-term strategic alliances",
      "Private-sector capital partners secured",
    ],
  },
  {
    year: "2026",
    title: "Commercial Structuring",
    items: [
      "Incorporation of FC Nairobi Ltd as Kenya’s first football club incorporated for commercial purposes only",
      "Infrastructure development aligned to long-term club sustainability",
      "International partnerships and governance alignment for investor readiness",
    ],
  },
  {
    year: "2027",
    title: "Vision Achieved",
    items: ["Full Implementation", "Sustainability Metrics", "Next Strategic Cycle"],
  },
];

export const kenyaStats = [
  { number: "18", label: "Member Clubs", icon: Trophy },
  { number: "55", label: "Million Population", icon: Users, suffix: "M" },
  { number: "13", label: "Million Students", icon: School, suffix: "M" },
  { number: "40", label: "Thousand Schools", icon: GraduationCap, suffix: "K+" },
];

export const rankings = [
  {
    icon: TrendingUp,
    value: "102",
    label: "FIFA World Ranking",
    note: "(Highest: 68 in 2009)",
  },
  {
    icon: MapPin,
    value: "23",
    label: "CAF Africa Ranking",
    note: "Current: 23rd in Africa",
  },
  {
    icon: Trophy,
    value: "7",
    suffix: "th",
    label: "Largest Economy in Africa",
    note: "GDP PPP",
  },
];

export const partners = [
  {
    name: "KickStart Kenya Football",
    url: "https://kickstartkenyafootball.com/",
    description: "Grassroots football development",
    logo: "https://kickstartkenyafootball.com/images/header-text-2.svg",
    logoAlt: "KickStart Kenya Football logo",
    logoWrapperClassName: "bg-white",
    logoClassName: "h-12 w-full max-w-[220px]",
  },
  {
    name: "Kenya Diaspora Alliance",
    url: "https://kenyadiasporaalliance.org/",
    description: "Connecting Kenyans worldwide",
    logo: "https://kenyadiasporaalliance.org/wp-content/uploads/2022/04/kda-logo-round.png",
    logoAlt: "Kenya Diaspora Alliance logo",
    logoWrapperClassName: "bg-white",
    logoClassName: "h-20 w-20",
  },
  {
    name: "FC Nairobi",
    url: "https://www.fcnairobi.com/",
    description: "Professional football club",
    logo: "https://customer-assets.emergentagent.com/job_football-club-site/artifacts/pdisthgd_V11%20FCN_badge%20%28transparent%20background%29%20copy.png",
    logoAlt: "FC Nairobi logo",
    logoWrapperClassName: "bg-white",
    logoClassName: "h-20 w-20",
  },
  {
    name: "Grilla",
    url: "https://www.drinkgrilla.com/",
    description: "Official beverage partner",
    logo: "https://kickstartkenyafootball.com/icons/grilla-logo.png",
    logoAlt: "Grilla logo",
    logoWrapperClassName: "bg-[#0A0A0A]",
    logoClassName: "h-12 w-full max-w-[180px]",
  },
];

export const values = [
  { icon: Target, title: "Aim High" },
  { icon: Handshake, title: "Achieve Together" },
  { icon: Heart, title: "Embrace Community" },
];